/**
 * Phase 6 Task 8 — reporting Zustand store.
 *
 * Holds the most-recent real-time dashboard snapshot pushed via
 * `dashboard:update` socket events and the result rows from any
 * historical report fetch.
 */
import { create } from 'zustand'
import type { DashboardSnapshot } from '@kc3/contracts'

export type { DashboardSnapshot }

interface ReportsStore {
  realtimeData: DashboardSnapshot | null
  historicalRows: unknown[]
  loading: boolean
  setRealtimeData(data: DashboardSnapshot): void
  setHistoricalRows(rows: unknown[]): void
  setLoading(loading: boolean): void
}

export const useReportsStore = create<ReportsStore>((set) => ({
  realtimeData: null,
  historicalRows: [],
  loading: false,
  setRealtimeData: (realtimeData) => set({ realtimeData }),
  setHistoricalRows: (historicalRows) => set({ historicalRows }),
  setLoading: (loading) => set({ loading }),
}))
